import { useRef, useState } from "react";

const UserDelagateAppSurveyReadOnlyRow = ({ index, t, delegateAppSurveyItem, handleDeleteClick, setEdit, oddIdx, setError, handleSubmit }) => {
	const [isSubmit, setIsSubmit] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const canReadRef = useRef(null);
	const [isCanRead, setIsCanRead] = useState(delegateAppSurveyItem.canRead);
	const canWriteRef = useRef(null);
	const [isCanWrite, setIsCanWrite] = useState(delegateAppSurveyItem.canWrite);
	const canReviewRef = useRef(null);
	const [isCanReview, setIsCanReview] = useState(delegateAppSurveyItem.canReview);
	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, delegateAppSurveyItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, delegateAppSurveyItem, submitComplete);
	}

	const onResponseChange = (event) => {
		//console.log(event.target + "  " + event.target.name + " " + event.target.checked);
		const { name, id } = event.target;
		//event.preventDefault();
		//event.stopPropagation();
		if (name.startsWith("canRead_")) {
			setIsCanRead(event.target.checked);
		} else if (name.startsWith("canWrite_")) {
			setIsCanWrite(event.target.checked);
		} else if (name.startsWith("canReview_")) {
			setIsCanReview(event.target.checked);
		}
	}

	function handleEditClick(event) {
		//event.preventDefault();
		//event.stopPropagation();
		setIsSubmit(false);
		setIsEditMode(true);
		setEdit(true);
	}

	function submitUpdate(event, delegateAppSurveyItem) {
		//event.preventDefault();
		//event.stopPropagation();
		setError("");
		setIsSubmit(true);
		let updatedValues = {
			userDelegateSurveyKey:delegateAppSurveyItem.userDelegateSurveyKey,
			userDelegateKey: delegateAppSurveyItem.userDelegateKey,
			delegateCompanyId: delegateAppSurveyItem.delegateCompanyId,
			buyerKey: delegateAppSurveyItem.buyerKey,
			level: delegateAppSurveyItem.level,
			appSurveyKey: delegateAppSurveyItem.appSurveyKey,
			canRead: canReadRef.current.checked,
			canWrite: canWriteRef.current.checked,
			canReview: canReviewRef.current.checked,
		};
		handleSubmit(2, updatedValues, submitUpdateComplete);
	}
	function submitUpdateComplete() {
		setIsSubmit(false);
		setIsEditMode(false);
		setEdit(false);
	}
	function submitCancel(event, delegateAppSurveyItem) {
		//event.preventDefault();
		//event.stopPropagation();
		setError("");
		setIsCanRead(delegateAppSurveyItem.canRead);
		setIsCanWrite(delegateAppSurveyItem.canWrite);
		setIsCanReview(delegateAppSurveyItem.canReview);
		setIsEditMode(false);
		setEdit(false);
		setIsSubmit(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{delegateAppSurveyItem.parentCompanyName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{delegateAppSurveyItem.appDisplayName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{delegateAppSurveyItem.surveyDisplayName}</td>
			{isEditMode ? (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input type="checkbox" className="mycheckbox"
							ref={canReadRef}
							name={"canRead_" + delegateAppSurveyItem.appSurveyKey}
							id={"canRead_" + delegateAppSurveyItem.appSurveyKey}
							defaultChecked={true}
							checked={isCanRead}
							onChange={onResponseChange}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input type="checkbox" className="mycheckbox"
							ref={canWriteRef}
							name={"canWrite_" + delegateAppSurveyItem.appSurveyKey}
							id={"canWrite_" + delegateAppSurveyItem.appSurveyKey}
							defaultChecked={true}
							checked={isCanWrite}
							onChange={onResponseChange}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input type="checkbox" className="mycheckbox"
							ref={canReviewRef}
							name={"canReview_" + delegateAppSurveyItem.appSurveyKey}
							id={"canReview_" + delegateAppSurveyItem.appSurveyKey}
							defaultChecked={true}
							checked={isCanReview}
							onChange={onResponseChange}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
				</>


			) : (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+delegateAppSurveyItem.canRead}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+delegateAppSurveyItem.canWrite}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+delegateAppSurveyItem.canReview}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{delegateAppSurveyItem.status}</td>
				</>
			)}

			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{isEditMode ? (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => submitUpdate(event, delegateAppSurveyItem)}>{t("page.submit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
							onClick={(event) => (submitCancel(event, delegateAppSurveyItem))}>{t("page.cancel")}</button>
					</>
				) : (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, delegateAppSurveyItem)}>
							{delegateAppSurveyItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
					</>
				)}

			</td>
		</tr>
	)
}
export default UserDelagateAppSurveyReadOnlyRow;